import styled from 'styled-components';

/**
 * The three status presentations from the design system.
 *
 *   .status  dot + coloured label   — a lifecycle position (ticket, order,
 *                                     reservation, survey, menu item)
 *   .badge   soft-filled pill       — a graded value (priority, urgency,
 *                                     contributor outcome)
 *   .tag     neutral pill           — a label that is not a state (role)
 *
 * Tone is carried by a class so one element covers every enum in the product.
 */

export const Dot = styled.span`
  display: inline-flex;
  align-items: center;
  gap: var(--s2);
  font-size: var(--fs-label);
  font-weight: var(--fw-medium);
  line-height: var(--lh-body);
  white-space: nowrap;

  i {
    width: 6px;
    height: 6px;
    flex: 0 0 6px;
    border-radius: 50%;
  }

  &.ok {
    color: var(--ok);
  }
  &.ok i {
    background: var(--ok);
    box-shadow: 0 0 0 3px var(--ok-soft);
  }

  &.info {
    color: var(--info);
  }
  &.info i {
    background: var(--info);
    box-shadow: 0 0 0 3px var(--info-soft);
  }

  &.warn {
    color: var(--warn);
  }
  &.warn i {
    background: var(--warn);
    box-shadow: 0 0 0 3px var(--warn-soft);
  }

  &.danger {
    color: var(--danger);
  }
  &.danger i {
    background: var(--danger);
    box-shadow: 0 0 0 3px var(--danger-soft);
  }

  &.purple {
    color: var(--purple);
  }
  &.purple i {
    background: var(--purple);
    box-shadow: 0 0 0 3px var(--purple-soft);
  }

  &.neutral,
  &.off {
    color: var(--text-faint);
  }
  &.neutral i,
  &.off i {
    background: var(--text-faint);
    box-shadow: 0 0 0 3px var(--neutral-soft);
  }
`;

export const Badge = styled.span`
  display: inline-block;
  padding: 3px var(--s2);
  border-radius: var(--r-pill);
  font-size: var(--fs-micro);
  font-weight: var(--fw-medium);
  line-height: var(--lh-body);
  white-space: nowrap;

  &.ok {
    background: var(--ok-soft);
    color: var(--ok);
  }
  &.info {
    background: var(--info-soft);
    color: var(--info);
  }
  &.warn {
    background: var(--warn-soft);
    color: var(--warn);
  }
  &.danger {
    background: var(--danger-soft);
    color: var(--danger);
  }
  &.purple {
    background: var(--purple-soft);
    color: var(--purple);
  }
  &.neutral,
  &.off {
    background: var(--neutral-soft);
    color: var(--text-muted);
  }
`;

/* A tag carries no tone — it is a name, not a state. */
export const Tag = styled(Badge)`
  background: var(--neutral-soft);
  color: var(--text-muted);
`;
